import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Homepage from './pages/Homepage';
import BookingSuccess from './pages/BookingSuccess';
import BookingCancelled from './pages/BookingCancelled';
import AdminLockerDashboard from './pages/AdminLockerDashboard';
import AdminAvailabilityPage from './pages/AdminAvailabilityPage';
import AdminLogin from './pages/AdminLogin';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route path="/booking-cancelled" element={<BookingCancelled />} />
            <Route path="/ub-gestione-2026" element={<AdminLogin />} />
            <Route path="/ub-gestione-2026/prenotazioni" element={<AdminLockerDashboard />} />
            <Route path="/ub-gestione-2026/disponibilita" element={<AdminAvailabilityPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
